import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import FullCalendar from '@fullcalendar/react' // must go before plugins
import dayGridPlugin from '@fullcalendar/daygrid' // a plugin!

import { complianecDateToEvent, concatAllComplianceDates } from 'utils/complianceDatesUtils';
import { openModal } from 'reducers/modalReducer';
import { MODAL_TYPES } from 'view/ModalManager';
import { getPropertyComplianceDates } from 'reducers/complianceDatesPortfolioReducer';

import Spinner from 'components/Spinner';

import './MonthCalendar.css';


const MonthCalendar = (props) => {
	const dispatch = useDispatch();
	const { propertyId, height, events } = props;
	const calendarHeight = height || 500;
	const {
		isLoading,
		complianceData,
	} = useSelector(state => ({
		isLoading: state.complianceDatesPortfolio.isLoading,
		complianceData: state.complianceDatesPortfolio.data || {},
	}));


	/* eslint-disable react-hooks/exhaustive-deps */
	useEffect(() => {
		if (events) {
			return;
		}
		if (propertyId) {
			dispatch(getPropertyComplianceDates(propertyId));
		}
	}, [propertyId, events, dispatch]);

	//todo: pass this in as param
	let onEventClick = (e) => {
		return dispatch(openModal(MODAL_TYPES.CALENDAR_EVENT, { 
			eventTitle: e.event.title,
		}));
	};

	if (props.onEventClick) {
		onEventClick = props.onEventClick;
	}

	let eventList = [] 
	if (events) {
		eventList = events;
	} else if (complianceData) {
		eventList = concatAllComplianceDates(complianceData).map(complianecDateToEvent);
	}

	return (
		<div className="calendar-month">
			{isLoading ? <Spinner /> :
				<FullCalendar
					plugins={[ dayGridPlugin ]}
					initialView="dayGridMonth"
					height={calendarHeight}
					events={eventList}
					eventClick={onEventClick}
					eventColor={props.eventColor}
				/>
			}
		</div>
	);	
}

export default MonthCalendar;
